// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-menu[data-v-6b401607]{min-width:0;min-width:auto}.transparent[data-v-6b401607]{backdrop-filter:blur(5px)!important;background-color:hsla(0,0%,100%,.5);box-shadow:0 0 5px 0 rgba(50,50,50,.45)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
